import { useRef } from 'react'

import { useDataContext } from 'context/data-context'
import { Container } from 'components/container'
import { VictimsList } from 'components/victims-list'
import { Layout } from 'components/layout'
import { parseMarkdown } from 'utils'
import { SmallModal } from 'components/modal/small'
import useBoolean from 'hooks/useBoolean'
import { FeaturedSlider } from './featured-slider'
import { Cols, Header, Introduction, ReadMore, Title, Video } from './styled'

export const Home = () => {
  const { translate } = useDataContext()
  const {
    value: isModalOpen,
    setTrue: openModal,
    setFalse: closeModal,
  } = useBoolean()
  const featuredContainerRef = useRef<HTMLDivElement | null>(null)

  return (
    <Layout>
      <Header>
        <Container>
          <Cols>
            <div>
              <Title>
                {translate('Politically Motivated Cases in Kyrgyzstan')}
              </Title>
              <Introduction className="underline">
                <p>
                  {translate('Intro text-visible')}
                  <ReadMore onClick={openModal}>
                    {translate('read more button')}
                  </ReadMore>
                </p>

                <SmallModal
                  isOpen={isModalOpen}
                  onClose={closeModal}
                  title={translate('Politically Motivated Cases in Kyrgyzstan')}
                >
                  {parseMarkdown(translate('intro-text-hidden'))}
                </SmallModal>
              </Introduction>
            </div>
            <Video autoPlay muted loop playsInline>
              <source src={process.env.PUBLIC_URL + '/video-hand.mp4'} />
            </Video>
          </Cols>
        </Container>
      </Header>

      <FeaturedSlider />

      <VictimsList ref={featuredContainerRef} />
    </Layout>
  )
}
